<template>
  <div>
    <!--{{ name }}-->
    <v-card>
      <v-form v-model="updateValid" lazy-validation ref="form">
      <v-card-text>

      <div class="notificationsDiv">
        <v-radio-group v-model="transactionType" required>

          <div class="radioGroup">
            <div class="full">
              <div class="toLeft">
                <label class="greyText">Deposit</label>
              </div>

              <div class="toRight">
                <v-radio
                  value="deposit"
                ></v-radio>
              </div>
            </div>

            <div class="full">
              <div class="toLeft">
                <label class="greyText">Withdraw</label>
              </div>

              <div class="toRight">
                <v-radio
                  value="withdrawal"
                ></v-radio>
              </div>
            </div>

          </div>
        </v-radio-group>
      </div>

      <div class="mt-2">
        <v-text-field
          label="Amount"
          type= "number"
          :rules="[checkAmount]"
          v-model= "amount"
          required
        ></v-text-field>
      </div>

      <div class="mt-2">
        <v-text-field
          label="Transaction Code"
          type= "string"
          :rules="transactionRules"
          v-model= "transaction"
          required
        ></v-text-field>
      </div>

      </v-card-text>

      <v-card-actions>
          <div style="float: left; width: 50%;">
            <v-btn flat color="blue" style="width: 100%;" @click="update">OK</v-btn>
          </div>
          <div style="float: right; width: 50%;">
            <v-btn flat color="error" style="width: 100%;" @click="dismiss">CANCEL</v-btn>
          </div>
      </v-card-actions>
      </v-form>
    </v-card>
  </div>

</template>

<script>
  export default {
    // We're gettings a savings object here
    data: () =>  ({
      updateValid: false,
      amount: null,
      transactionType: 'deposit',
      transaction: null,
      transactionRules: [
        v => !!v || 'Code is required'
      ],
      amountRules: [
    v => !!v || 'Please enter a valid amount',
    v => /^[1-9][0-9]{0,200}$/.test(v) || 'Please enter a valid number'
    ],
    }),
    props: ['savings'],
    methods: {
      update() {

        let payload = {
          _id: this.savings._id,
          name: this.savings.name,
          type: this.transactionType,
          amount: this.amount,
          transactionCode: this.transaction
        }


        this.$store.dispatch('updateSavings', payload).then(() => {
          this.$refs.form.reset();
          this.$emit('dismiss')
        });

      },
      dismiss() {
        this.$refs.form.reset();
        this.$emit('dismiss')
      }
    },
    computed: {
      checkAmount(){

        if(!this.amount) {
          return true;
        }

        if(this.amount > (this.savings.targetAmount - this.savings.currentAmount)){
          return 'Deposit more than remaining amount';
        } else if (this.amount.includes('-') || this.amount.includes('+') || this.amount[0] === '0' || !this.amount){
          return 'Please enter a valid input';
        } else {
          return true;
        }
      }
    }
  }
</script>

<style scoped>

  .v-radio {
    margin-right: 0 !important;
  }

  .greyText {
    color: #868787;
  }

  .inputWidth {
    width: 70%;
  }

  .notificationsDiv {
    height: 60px;
  }

  .radioGroup {
    width: 100%;
    display: block;
  }

  .full {
    width: 100%;
    height: 32px;
  }

  .toRight {
    float:right;
  }

  .toLeft {
    float: left;
  }

</style>



// WEBPACK FOOTER //
// src/components/Shared/Update.vue